import React from 'react';
import { styled, Tooltip, tooltipClasses } from '@mui/material';
import { useEffect } from 'react';
import Axios from '../../axios/Axios';
import axios from 'axios';

export const ShowListInTooltip = ({ value, getUrl, property }) => {

  const [listData, setListData] = React.useState([]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 11,
      border: '1px solid #A7AFB3'
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#FFFFFF',
      '&::before': {
        border: '1px solid #A7AFB3'
      }
    }
  }));

  // const StyledTooltip = ({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ tooltip: className }} />
  // );

  // const LightTooltip = styled(StyledTooltip)(({theme}) => ({
  //     backgroundColor: 'white',
  //     color: 'black',
  //     maxWidth: 500,
  //     fontSize: "15px",
  //     boxShadow: theme.shadows[5],
  //   // arrow: {
  //   //   color: '#FFFFFF',
  //   //   '&::before': {
  //   //     border: '2px solid #A7AFB3'
  //   //   }
  //   // }
  // }))

  useEffect(() => {
    const controller = axios.CancelToken.source();

    (async () => {
      try {
        const response = await Axios("get", getUrl, true, null, { cancelToken: controller.token });

        if (response.status === 200) {
          // console.log(response.data.hasOwnProperty("resultdata"));

          response.data.hasOwnProperty("resultdata") ?
            setListData(response.data.resultdata) :
            setListData(response.data);
        }
      } catch (error) {
        if (!axios.isCancel(error)) { console.log(error); }

      }
    })()
    return () => {
      controller.cancel();
    }
  }, [getUrl])

  const ListInTooltip = (
    listData.length !== 0 &&
    listData.map((item, index) => {
      return (<p style={{ fontWeight: 900, fontSize: "13px" }} key={index}>{item[property]}</p>)
    })
  )

  return (
    <LightTooltip
      title={ListInTooltip}
      placement="right"
      arrow
    // disableHoverListener
    // disableFocusListener
    // disableTouchListener
    >
      <span style={{ cursor: "pointer" }}>({value})</span>
    </LightTooltip>
  )
}
